"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.curry = curry;
exports.currySoft = currySoft;
exports.curryHard = curryHard;
exports.currySmart = currySmart;

var _react = _interopRequireDefault(require("react"));

var _reactDisplayName = _interopRequireDefault(require("react-display-name"));

var _reducers = require("./reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function curry(reactElement, displayName) {
  var propsReducer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _reducers.allowOverwrite;
  var curriedProps = reactElement.props,
      CurriedType = reactElement.type;

  var curriedComponent = function Curried(props) {
    var combinedProps = propsReducer(curriedProps, props);
    return _react["default"].createElement(CurriedType, combinedProps);
  };

  curriedComponent.displayName = displayName || "Curried(".concat((0, _reactDisplayName["default"])(CurriedType), ")");
  curriedComponent.propTypes = CurriedType.propTypes;
  return curriedComponent;
}

function currySoft(reactElement, displayName) {
  return curry(reactElement, displayName, _reducers.allowOverwrite);
}

function curryHard(reactElement, displayName) {
  return curry(reactElement, displayName, _reducers.forceCurry);
}

function currySmart(reactElement, displayName) {
  var isHard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var propsReducer = function propsReducer(curriedProps, props) {
    return (0, _reducers.mergeComplexProps)(curriedProps, props, isHard);
  };

  return curry(reactElement, displayName, propsReducer);
}